export default __webpack_public_path__ + "static/media/arrow_dropdown_filter.6eccf48a.svg";